import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ResourceVm } from 'qp-ui-interface';
import { DeviceTypeModel, getDeviceType } from 'qp-utility';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { SideModalComponent } from '../../shared-components/side-modal/side-modal.component';
import { isLoggedIn } from '../../utils/LoginUtils';
import { isExplicitContent } from '../../utils/ParentalPinUtils';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ParentalControlDialogService {
  constructor(private dialog: MatDialog, private translate: TranslateService, private configService: ConfigService, private readonly localStorage: LocalStorageService) {}

  async checkExplicitContent(resource: ResourceVm): Promise<boolean> {
    if (
      !isLoggedIn(this.localStorage) &&
      isExplicitContent(this.configService, resource) &&
      (getDeviceType() === DeviceTypeModel.VIZIO || getDeviceType() === DeviceTypeModel.LG)
    ) {
      // only for anonymous users
      return this.dialog
        .open(SideModalComponent, {
          id: 'explicit-content-dialog',
          data: {
            title: this.translate.instant('warning.header'),
            message: this.translate.instant('warning.body'),
            buttonAction: this.translate.instant('warning.button'),
          },
        })
        .afterClosed()
        .toPromise();
    } else {
      return Promise.resolve(true);
    }
  }
}
